import styled, { css } from 'styled-components';
import { ChevronIcon } from '@sainsburys-tech/bolt-icons';
import { Alert } from '@sainsburys-tech/bolt';
var ProductCareCTA = styled.button.withConfig({
  displayName: "ProductCareItemstyles__ProductCareCTA",
  componentId: "gdkb56-0"
})(["display:flex;justify-content:space-between;align-items:center;padding:15px;border-radius:", ";z-index:2;cursor:pointer;font-size:1rem;width:100%;font-family:inherit;background:none;border:", ";margin-top:10px;color:", ";", " @media only screen and (max-width:", "){margin-top:15px;}:focus,:active,:hover{border-color:", ";border-width:", ";border-radius:", ";color:", ";margin:-1px;margin-top:9px;padding-right:13px;@media only screen and (max-width:", "){margin:-1px;margin-top:14px;}}:focus{border-color:", ";outline:none;}"], function (props) {
  return props.theme.size.border.radius.base;
}, function (props) {
  return "".concat(props.theme.size.border.width.sm, " solid ").concat(props.theme.color.monochrome.base);
}, function (props) {
  return props.theme.color.monochrome.dark;
}, function (props) {
  return props.showInfoMessage && css(["flex-direction:column;text-align:left;"]);
}, function (props) {
  return props.theme.size.breakpoint['max-width'].sm;
}, function (props) {
  return props.theme.color.monochrome.base;
}, function (props) {
  return props.theme.size.border.width.md;
}, function (props) {
  return props.theme.size.border.radius.lg;
}, function (props) {
  return props.theme.color.monochrome.darker;
}, function (props) {
  return props.theme.size.breakpoint['max-width'].sm;
}, function (props) {
  return props.theme.color.palette['brand-1-dark'];
});
var Title = styled.span.withConfig({
  displayName: "ProductCareItemstyles__Title",
  componentId: "gdkb56-1"
})(["text-align:left;align-self:center;"]);
var ProductCarePriceContainer = styled.div.withConfig({
  displayName: "ProductCareItemstyles__ProductCarePriceContainer",
  componentId: "gdkb56-2"
})(["display:flex;"]);
var ChevronContainer = styled(ChevronIcon).withConfig({
  displayName: "ProductCareItemstyles__ChevronContainer",
  componentId: "gdkb56-3"
})(["align-self:center;"]);
var Wrapper = styled.div.withConfig({
  displayName: "ProductCareItemstyles__Wrapper",
  componentId: "gdkb56-4"
})(["display:flex;justify-content:space-between;width:100%;"]);
var BoltAlert = styled(Alert).withConfig({
  displayName: "ProductCareItemstyles__BoltAlert",
  componentId: "gdkb56-5"
})(["margin:10px 0 -2px;"]);
export { ProductCareCTA, Title, ProductCarePriceContainer, ChevronContainer, Wrapper, BoltAlert };